import Cookies from 'js-cookie';

const key = 'fontSizeFactor';

export function getFontSizeFactor() {
    return Cookies.get(key);
}

export function setFontSizeFactor(factor) {
    return Cookies.set(key, factor);
}

